<template>
  <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
  <div class="has-background-white has-text-black-bis has-radius-top-left generic-settings" key="refreshkey">
    <div class="column">
      <div class="columns">
        <div class="column is-flex is-align-items-center is-justify-content-end">
          <div v-if="!edit" class="is-flex">
            <button class="button p-0 has-text-black-bis mr-2" @click="isActivityActive = true">
             <i class="icon-activityhistory"></i>
            </button>
            <div class="is-divider-vertical" v-if="hasPermission"></div>
            <button class="button p-0 has-text-black-bis" v-if="hasPermission" @click="toggleEdit()">
              <i class="icon-edit"></i>
            </button>
          </div>
          <div v-else-if="edit" class="buttons">
            <button class="button is-outlined is-danger p-0" @click="() => closeEdit()">
              <i class="icon-close"></i>
            </button>
            <button class="button is-success has-text-white p-0" @click="saveCompany()">
              <i class="icon-checkmark"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="column" v-if="edit">
      <div class="columns">
        <div class="column">
          <div class="has-background-grey-lighter has-text-black-bis account-tab">
            <h3 class=" is-size-3 has-text-weight-bold line-height mb-2">Account Type:</h3>
            <h4 class="is-size-4 line-height">{{ $_.get(company,
              'tenDukeDetails.licenseDetails.licensedItem.displayName',
              company.license)}}</h4>
            <h4 class="is-size-4 line-height">(Please contact
              <a href="mailto:support@manufacton.com">ManufactOn Support</a>
              to change your license type)
            </h4>
            <h3 class=" is-size-3 has-text-weight-bold line-height mb-3">Billing</h3>
            <div class="mb-3 is-flex is-flex-direction-row">
              <i class="icon-genericuserfull has-text-black-bis mr-2"></i> <input placeholder="Billing" class="input"
                v-model.trim="company.billingName">

            </div>
            <div class="mb-3 is-flex is-flex-direction-row">
              <i class="icon-email has-text-black-bis mr-2"></i><input placeholder="Billing" class="input"
                v-model.trim="company.billingEmail">
            </div>
            <h3 class=" is-size-3 has-text-weight-bold line-height mb-3">Website</h3>
            <div class="mb-3 is-flex is-flex-direction-row">
              <i class="icon-url has-text-black-bis mr-2"></i><input placeholder="Website" class="input m-b-15"
                v-model.trim="company.website">
            </div>
            <div class="company-logo">
              <div class="column">
                <div class="columns">
                  <div class="column">
                    <img v-if="hasCompLogo" :src="imageUrl" @error="handleLogoImageError">
                  </div>
                  <div class="column is-6 is-flex is-align-items-center is-justify-content-start">
                    <mf-file accept="image/png, image/jpeg" path="companies/addCompanyLogo" :isImageUpload="true"
                      :multiple="false" filePath="imageUrl" :param="{ company: company._id, type: 'companies' }"
                      @onInput="handleLogoUpload" :hideLimitText="true" class="is-pulled-right">
                      Add Image
                    </mf-file>
                  </div>
                </div>
              </div>
              
             
            </div>
          </div>
        </div>
        <div class="column">
          <div class="has-background-grey-lighter account-tab">
            <h3 class=" is-size-3 has-text-weight-bold line-height">Address 1:</h3>
            <div class="column">
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-home is-size-1 has-text-black-bis"></i>
                </div>
                <div class="column">
                  <input class="input" placeholder=" Company Name" v-model.trim="company.name">
                  <p v-if="!company.name" class="has-text-danger is-size-6 ">
                    <i class="fas fa-exclamation-triangle"></i> Name is Required!
                  </p>
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-attachedlocations"></i>
                </div>
                <div class="column">
                  <input placeholder="Street" class="input mb-4" v-model.trim="company.addr1.street">
                  <input placeholder="City" class="input mb-4" v-model.trim="company.addr1.city">
                  <input placeholder="State" class="input mb-4" v-model.trim="company.addr1.state">
                  <input placeholder="Country" class="input mb-4" v-model.trim="company.addr1.country">
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-phone is-size-1 has-text-black-bis"></i>
                </div>
                <div class="column pt-0">
                  <input placeholder="Phone" class="input" v-model.trim="company.addr1.phone" v-if="company.addr1">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column" v-if="company.addr2">
          <div class="has-background-grey-lighter account-tab">
            <h3 class=" is-size-3 has-text-weight-bold line-height mb-2">Address 2:
              <span class="has-text-grey-light is-size-6">(optional)</span>
            </h3>
            <div class="column">
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-attachedlocations"></i>
                </div>
                <div class="column">
                  <input placeholder="Street" class="input mb-4" v-model.trim="company.addr2.street">
                  <input placeholder="City" class="input mb-4" v-model.trim="company.addr2.city">
                  <input placeholder="State" class="input mb-4" v-model.trim="company.addr2.state">
                  <input placeholder="Country" class="input mb-4" v-model.trim="company.addr2.country">
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-phone is-size-1 has-text-black-bis"></i>
                </div>
                <div class="column pt-0">
                  <input placeholder="Phone" class="input" v-model.trim="company.addr2.phone">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column" v-if="!edit">
      <div class="columns">
        <div class="column">
          <div class="has-background-grey-lighter has-text-black-bis account-tab">
            <h3 class=" is-size-3 has-text-weight-bold line-height">Account Type</h3>
            <p class="line-height">{{ $_.get(company, 'tenDukeDetails.licenseDetails.licensedItem.displayName',
              company.license) }}</p>
            <p class="line-height">
              (Please contact
              <a href="mailto:support@manufacton.com">ManufactOn Support</a>
              to change your license type)
            </p>
            <h3 class=" is-size-3 has-text-weight-bold line-height">Billing</h3>
            <div class="is-flex is-flex-direction-row line-height">
              <i class="icon-genericuser mr-2"></i> {{company.billingName ?  " " + company.billingName : '' }}
            </div>
            <div class="is-flex is-flex-direction-row line-height mb-3">
              <i class="icon-email mr-2"></i> {{ company.billingEmail }}
            </div>
            <h3 class=" is-size-3 has-text-weight-bold line-height">Website</h3>
            <div class="mb-3 is-flex is-flex-direction-row line-height">
              <i class="icon-url mr-2"></i> {{company.website ?  " " + company.website : '' }}
            </div>
            <h3 class=" is-size-3 has-text-weight-bold line-height">Company Logo</h3>
            <div class="company-logo">
              <img :src="imageUrl" v-if="hasCompLogo" @error="handleLogoImageError">
            </div>
          </div>
        </div>
        <div class="column">
          <div class="has-background-grey-lighter has-text-black-bis account-tab">
            <h3 class=" is-size-3 has-text-weight-bold line-height">Address 1:</h3>
            <div class="column">
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-home is-size-1"></i>
                </div>
                <div class="column">
                  <p class="line-height"> {{company.name ?  " " + company.name : ''}}</p>
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-attachedlocations"></i>
                </div>
                <div class="column" v-if="company.addr1">
                  <p class="line-height">{{ company.addr1.street }}</p>
                  <p class="line-height">{{ company.addr1.city }}</p>
                  <p class="line-height">{{ company.addr1.state }}</p>
                  <p class="line-height">{{ company.addr1.country }}</p>
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-phone is-size-1 fa-flip-horizontal"></i>
                </div>
                <div class="column" v-if="company.addr1">
                  <p class="line-height" v-if="company.addr1.phone">{{ company.addr1.phone }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="has-background-grey-lighter has-text-black-bis account-tab">
            <h3 class=" is-size-3 has-text-weight-bold line-height">Address 2:
              <span class="has-text-grey-light is-size-5">(optional)</span>
            </h3>
            <div class="column">
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-attachedlocations"></i>
                </div>
                <div class="column has-text-black-bis" v-if="company.addr2">
                  <p class="line-height">{{ company.addr2.street }}</p>
                  <p class="line-height">{{ company.addr2.city }}</p>
                  <p class="line-height">{{ company.addr2.state }}</p>
                  <p class="line-height">{{ company.addr2.country }}</p>
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow">
                  <i class="icon-phone is-size-1 fa-flip-horizontal"></i>
                </div>
                <div class="column" v-if="company.addr2">
                  {{ company.addr2.phone }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column" v-if="edit">
      <div class="columns">
        <div class="column">
          <div class="has-background-grey-lighter p-2 is-border-radius-sm">
            <h3 class="has-text-weight-bold is-size-3 mb-3">Project Purchase Order Numbers</h3>
            <o-checkbox v-model="company.generatePon">
              Generate
            </o-checkbox>
            <div class="column">
              <div class="columns">
                <div class="column">
                  <h4 class="has-text-weight-semibold is-size-3"><span class="is-pulled-left mr-2">Prefix:</span></h4>
                  <input class="input" placeholder="(18 characters max)" v-model.trim="company.purchaseOrderNumber.prefix"
                    @input="company.purchaseOrderNumber.prefix = updateParams($event)">
                </div>
                <div class="column">
                  <h4 class="has-text-weight-semibold is-size-3"><span class="is-pulled-left mr-2">Start At:</span></h4>
                  <input class="input" placeholder="start" v-model.trim="company.purchaseOrderNumber.start" min="6" max="6"
                    @input="company.purchaseOrderNumber.start = updateParams($event)" type="number"
                    :disabled="(!$_.isEmpty(company.purchaseOrderNumber.prefix) &&
                    company.purchaseOrderNumber.nextNumber != company.purchaseOrderNumber.start)">
                </div>
                <div class="column">
                  <h4 class="has-text-weight-semibold is-size-3"><span class="mr-2">Next Number:</span></h4>
                  <p class="is-pulled-left mr-2"
                      v-if="!$_.isEmpty($_.get(company, 'purchaseOrderNumber.prefix', ''))">
                      {{ $_.get(company, 'purchaseOrderNumber.prefix', '') }}{{ $_.get(company,
                        'purchaseOrderNumber.nextNumber', '') }}
                    </p>
                    <h4 v-else
                      class="has-text-weight-semibold has-text-grey-light is-size-3 line-height">N/A</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="has-background-grey-lighter p-2 is-border-radius-sm">
            <h3 class="has-text-weight-bold is-size-3 mb-2 line-height">
              Production Order Materials
            </h3>
            <p class="is-size-3 line-height mb-5">
              <o-checkbox v-model="company.autoReserve">
                Automatically Reserve Materials (when moving orders from Detailing to Manufacturing)
              </o-checkbox>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="column" v-if="!edit">
      <div class="columns">
        <div class="column">
          <div class="has-background-grey-lighter p-2 is-border-radius-sm">
            <h3 class="has-text-weight-bold is-size-3 mb-3">Project Purchase Order Numbers</h3>
            <h4 class="is-size-3 mb-3 has-text-weight-semibold mb-3 has-text-grey-light">Generation is<span
                v-if="company.generatePon">Enabled</span><span v-else>Disabled</span> </h4>
            <h3 class="has-text-weight-semibold is-size-3 mb-3">Purchase Order Number</h3>
            <div class="column">
              <div class="columns">
                <div class="column">
                  <h4 class="has-text-weight-semibold is-size-3"><span class="is-pulled-left mr-2">Prefix:</span> <span
                      class="is-pulled-left  mr-2"
                      v-if="!$_.isEmpty($_.get(company, 'purchaseOrderNumber.prefix', ''))">{{
                        company.purchaseOrderNumber.prefix }}
                    </span><span v-else class="has-text-weight-semibold has-text-grey-light is-pulled-left"> N/A</span>
                  </h4>
                </div>
                <div class="column">
                  <h4 class="has-text-weight-semibold is-size-3">
                    <span class="is-pulled-left mr-2">Start At:</span><span class="is-pulled-left mr-2"
                      v-if="!$_.isEmpty($_.get(company, 'purchaseOrderNumber.prefix', ''))">{{ $_.get(company,
                        'purchaseOrderNumber.start',
                      '')}}</span><span v-else
                      class="is-pulled-left has-text-weight-semibold has-text-grey-light is-size-3"> N/A</span>
                  </h4>
                </div>
                <div class="column">
                  <h4 class="has-text-weight-semibold is-size-3"><span class="is-pulled-left mr-2">Next Number:</span>
                    <span class="is-pulled-left mr-2"
                      v-if="!$_.isEmpty($_.get(company, 'purchaseOrderNumber.prefix', ''))">
                      {{ $_.get(company, 'purchaseOrderNumber.prefix', '') }}{{ $_.get(company,
                        'purchaseOrderNumber.nextNumber', '') }}
                    </span>
                    <span v-else
                      class="has-text-weight-semibold has-text-grey-light is-size-3 is-pulled-left">N/A</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="has-background-grey-lighter p-2 is-border-radius-sm">
            <h3 class="has-text-weight-bold is-size-3 mb-2 line-height">
              Production Order Materials
            </h3>
            <p class="is-size-3 line-height mb-5">
              <o-checkbox v-model="company.autoReserve" disabled>
                Automatically Reserve Materials (when moving orders from Detailing to Manufacturing)
              </o-checkbox>
            </p>
          </div>
        </div>
      </div>
    </div>
    <activity-slider
      :isActive="isActivityActive"
      :id="companyId"
      module="Company"
      :company="companyId"
      @update:isActive="isActivityActive = false"
    />
  </div>
</template>
<script>
import {
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  ref,
  toRefs,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import MfFile from '@/components/MfFilePicker.vue';
import Validation from '@/utils/Validations'
import Projects from '@/models/Projects';
import s3FileAccess from '@/models/SimpleStorageService';
import Companies from '@/models/Companies';
import ActivitySlider from '@/components/ActivitySlider.vue';
import PermissionMixin from '@/components/mixins/PermissionMixin';
import { cloneDeep } from 'lodash';

export default defineComponent({
  name: 'CompanyInfo',
  components: {
    'mf-file': MfFile,
    ActivitySlider,
  },
  setup(props) {
    const toast = useToast();
    const store = useStore();
    const { getPermissionValues } = PermissionMixin();
    const data = reactive({
      edit: false,
      companyClone: {},
      imageUrl: '',
      hasCompLogo: false,
      isActivityActive: false,
      company: {},
      hasPermission: true,
      refreshkey: 0,
      isLoading: false,
    });
    const updateParams = (e) => {
      let nextPrefix = e.toUpperCase();
      const existingPrefix = data.company.purchaseOrderHistory.find(item => item.prefix === nextPrefix);
      if (nextPrefix === data.companyClone.purchaseOrderNumber.prefix) {
        data.company.purchaseOrderNumber.start = data.companyClone.purchaseOrderNumber.start;
        data.company.purchaseOrderNumber.nextNumber = data.companyClone.purchaseOrderNumber.nextNumber;
      } else if (existingPrefix) {
        data.company.purchaseOrderNumber.start = existingPrefix.start;
        data.company.purchaseOrderNumber.nextNumber = existingPrefix.nextNumber;
      } else {
        data.company.purchaseOrderNumber.start = '000001';
        data.company.purchaseOrderNumber.nextNumber = '000001';
      }
      return nextPrefix;
    };

    const companyId = computed(() => store.state.userData?.company || '');
    const update = (e) => {
      let orderNumber = e.target.value;
      orderNumber = orderNumber.toString();
      if (orderNumber.length > 6 || orderNumber.length === 0) orderNumber = '000001';
      data.company.purchaseOrderNumber.nextNumber = orderNumber;
      return orderNumber;
    };

    const getCompLogo = async () => {
      const fileGuid = data.company.logo?.fileGuid || '';
      if (data.company._id && fileGuid !== '') {
        const { presignedUrl } = await s3FileAccess.getS3File({
          type: 'company',
          id: fileGuid,
        });
        data.imageUrl = presignedUrl;
        data.hasCompLogo = true;
        return true;
      }
      data.imageUrl = '';
      data.hasCompLogo = false;
      return false;
    };

    const handleLogoUpload = async (file) => {
      data.company.logo = file || { fileGuid: '' };
      await getCompLogo();
    };

    const handleLogoImageError = () => {
      data.imageUrl = '';
      data.hasCompLogo = false;
    };

    const getCompany = async () => {
      const userCompany = await Companies.getOne(data.company._id || '');      
      return userCompany;
    };

    const toggleEdit = () => {
      data.edit = !data.edit;
    };
    const closeEdit = () => {
      data.company = cloneDeep(data.companyClone);
      data.edit = !data.edit;
      data.refreshkey++;
    }
    
    const saveCompany = async () => {
      if (!validations()) return;
      if (!_.isEmpty(data.company.purchaseOrderNumber.prefix)) {
        const allowToSave = await Projects.getProjectWithPrefix({
          prefix: data.company.purchaseOrderNumber.prefix,
        });
        if (allowToSave > 0) {
          toast.error('That Purchase Order Prefix is in use - please select another');
          return;
        }
      }
      const latestCompany = await Companies.save(data.company);
      data.edit = false;
      data.company = latestCompany;
      data.companyClone = cloneDeep(data.company)
      await store.dispatch('getCompanyData');
    };

    onMounted(async () => {
      data.isLoading = true;
      getCompLogo();
      data.company = await getCompany();
      data.companyClone = cloneDeep(data.company)      
      if (_.isEmpty(data.company.addr1) || _.isUndefined(data.company.addr1)) {
        data.company.addr1 = { street: '', city: '', state: '', country: '', phone: '' };
      }
      if (_.isEmpty(data.company.addr2) || _.isUndefined(data.company.addr2)) {
        data.company.addr2 = { street: '', city: '', state: '', country: '', phone: '' };
      }
      data.hasPermission = !(getPermissionValues({
        permissionModule: 'app&projects',
        type: 'alterAccount',
      }))
      data.isLoading = false;
    });

    const validations = () => {
      let isValid;
      const validationArr = ['billingName', 'billingEmail', 'website', 'name'];
      _.forEach(validationArr, (detail) => {
        if (_.isEmpty(data.company[detail])
        || (!_.isEmpty(data.company[detail]) && _.isEmpty(data.company[detail].trim()))) {
          toast.error(`Please fill the ${_.startCase(detail)}`);
          isValid = false;
          return false;
        }
        isValid = true;
      });
      if (!isValid) { return false; }
      const rgex = new RegExp('^(http|https)://', 'i');
      if (!_.isEmpty(data.company.website) && !data.company.website.match(rgex)) {
        data.company.website = `http://${data.company.website}`;
      }
      if (_.isEmpty(data.company.addr1.street)
      || (!_.isEmpty(data.company.addr1.street) && _.isEmpty(data.company.addr1.street.trim()))) {
        toast.error('please enter the valid street for Address 1');
        return false;
      }
      if (_.isEmpty(data.company.addr1.city)
      || (!_.isEmpty(data.company.addr1.city) && _.isEmpty(data.company.addr1.city.trim()))) {
        toast.error('please enter the valid city for Address 1');
        return false;
      }
      if (_.isEmpty(data.company.addr1.state)
      || (!_.isEmpty(data.company.addr1.state) && _.isEmpty(data.company.addr1.state.trim()))) {
        toast.error('please enter the valid state for Address 1');
        return false;
      }
      if (_.isEmpty(data.company.addr1.country)
      || (!_.isEmpty(data.company.addr1.country) && _.isEmpty(data.company.addr1.country.trim()))) {
        toast.error('please enter the valid country for Address 1');
        return false;
      }
      if (!_.isEmpty(data.company.addr1.phone)
       && !Validation.validatePhoneNumber(data.company.addr1.phone, true, toast)) {
        return false;
      }
      if (!_.isEmpty(data.company.addr2.phone)
       && !Validation.validatePhoneNumber(data.company.addr2.phone, true, toast)) {
        return false;
      }
      return true;
    }

    watch(
      () => [data.company._id, data.company.logo?.fileGuid || ''],
      () => {
        getCompLogo();
      },
    );

    return {
      ...toRefs(data),
      updateParams,
      update,
      getCompLogo,
      handleLogoUpload,
      handleLogoImageError,
      getCompany,
      toggleEdit,
      saveCompany,
      validations,
      companyId,
      closeEdit,
    };
  },
});
</script>
